import React from "react";

const SubCards = ({ items = [] }) => {
  return (
    <ul className="text-white text-left text-md italic">
      {items.map((item) => (
        <li>{item}</li>
      ))}
    </ul>
  );
};

export default SubCards;
